// src/app/core/auth/pwd-change.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const pwdChangeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Must have a token (partial JWT)
  if (!authService.token()) {
    return router.createUrlTree(['/login']);
  }

  // Must actually need password change
  if (!authService.requiresPasswordChange()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
